import React, { useEffect, useState } from 'react'
import { useRoot, useUserList } from 'Hooks'
import { Layout, Menu } from 'antd'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { CheckCircleOutlined, DashboardOutlined, MenuFoldOutlined, MenuUnfoldOutlined, TableOutlined, UserOutlined, WarningOutlined } from '@ant-design/icons'
import * as _ from 'lodash'

const { Sider } = Layout

const getItemSideBar = (label, key, icon, children, to, type) => ({
  key,
  icon,
  children,
  label,
  to,
  type
})

export const dataSideBar = (t, children) => [
  {
    key: 'dashboard',
    icon: <DashboardOutlined />,
    label: t('sidebar.dashboard'),
    to: '/dashboard'
  },
  {
    key: 'user-list',
    icon: <TableOutlined />,
    label: t('sidebar.user_list'),
    to: '/user-list',
    children
  },
  {
    key: 'payment',
    icon: <CheckCircleOutlined />,
    label: t('sidebar.payment'),
    to: '/payment'
  },
  {
    key: 'contact',
    icon: <WarningOutlined />,
    label: t('sidebar.contacts'),
    to: '/contact'
  },
  {
    key: 'account',
    icon: <UserOutlined />,
    label: t('sidebar.account'),
    to: '/account'
  }
]

const sideBarUser = (t, children, userName) => [
  getItemSideBar(userName, 'sub-user', null, children, null)
]

const sideBarChildrenPortfolio = (t, userId, portId) => [
  getItemSideBar(t('sidebar.dashboard'), `sub-dashboard-${portId}`, null, null, `/user/${userId}/portfolio/${portId}/dashboard`),
  getItemSideBar(t('sidebar.weekly'), `sub-weekly-${portId}`, null, null, `/user/${userId}/portfolio/${portId}/weekly`),
  getItemSideBar(t('sidebar.head_count'), `sub-headcount-${portId}`, null, null, `/user/${userId}/portfolio/${portId}/head-count`)
]

const SideBar = () => {
  const [activeKey, setActiveKey] = useState(['1'])
  const [activeSideBar, setActiveSideBar] = useState([])
  const { t } = useTranslation('menu')
  const { idUser, idPortfolio } = useParams()
  const [itemSideBar, setItemSideBar] = useState(dataSideBar(t))
  const location = useLocation()
  const { sidebarCompact, toggleSidebarAction } = useRoot()
  const { info, portfolios, getAllPortfolioByUserIdAction } = useUserList()
  const history = useHistory()

  useEffect(() => {
    if (location.pathname.split('/')[1] === 'user') {
      const arrSideBar = []
      if (portfolios?.length > 0) {
        portfolios.map((data) => {
          arrSideBar.push(getItemSideBar(data.client_name, data.id.toString(), null,
            sideBarChildrenPortfolio(t, idUser, data.id)))
          return null
        })
      }
      const data = sideBarUser(t, arrSideBar, info?.userName)
      setItemSideBar(dataSideBar(t, data))
      if (idPortfolio) {
        const result = _.chain(data[0].children)
          .map('children').flatten().value()
        const active = result.find((_item) => _item.to === location.pathname)
        if (active) {
          setActiveKey(active.key.toString())
        }
      }
    } else {
      const path = `/${location.pathname.split('/')[1]}`
      const active = dataSideBar(t).find((_item) => _item.to === path)
      if (active) {
        setActiveKey(active.key.toString())
      }
      setItemSideBar(dataSideBar(t))
    }
  }, [portfolios, idPortfolio, info])

  useEffect(() => {
    if (idPortfolio) {
      setActiveSideBar(['user-list', 'sub-user', idPortfolio.toString()])
    }
  }, [idPortfolio])

  useEffect(() => {
    if (idUser) {
      getAllPortfolioByUserIdAction({ userId: idUser })
    }
  }, [idUser])

  return (
    <>
      <Sider
        trigger={null}
        collapsible
        collapsed={sidebarCompact}
        theme="light"
        width={240}
        className="sider-class"
        style={{ zIndex: '10' }}
      >
        <Menu
          mode="inline"
          selectedKeys={[activeKey]}
          openKeys={activeSideBar}
          onOpenChange={(openKeys) => {
            setActiveSideBar(openKeys)
          }}
          items={itemSideBar}
          onClick={({ item }) => {
            history.push(item.props.to)
          }}
        />
        <button className="collapse" onClick={() => toggleSidebarAction()}>
          {sidebarCompact ? <MenuUnfoldOutlined style={{ fontSize: '16px' }} /> : <MenuFoldOutlined style={{ fontSize: '16px' }} /> }
        </button>
      </Sider>
    </>
  )
}

export default SideBar
